import React from 'react';
import PropTypes from 'prop-types';

import {Field} from 'redux-form';
import FieldText from '../../fields/fieldText/FieldText';

export default function ConstructedTextField({field}) {
  return (
    <Field
      name={field.code}
      label={`${field.name} ${field.required ? '*' : ''}`}
      required={field.required}
      component={FieldText}
    />
  );
}



// WEBPACK FOOTER //
// ./components/constructedForm/fields/ConstructedTextField.js